export class Notification {
    'id';
    'projectId';
    'timestamp';
    'policyId';
    'policyName';
    'type';
    'status';
    'arguments';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "projectId",
            "baseName": "projectId",
            "type": "string",
            "format": ""
        },
        {
            "name": "timestamp",
            "baseName": "timestamp",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "policyId",
            "baseName": "policyId",
            "type": "string",
            "format": ""
        },
        {
            "name": "policyName",
            "baseName": "policyName",
            "type": "string",
            "format": ""
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "NotificationType",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "NotificationStatus",
            "format": ""
        },
        {
            "name": "arguments",
            "baseName": "arguments",
            "type": "NotificationArguments",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return Notification.attributeTypeMap;
    }
    constructor() {
    }
}
